import { ReactNode } from 'react';
import type { CommonHTMLAttributes } from '@frontend/types';
import { Text } from '@frontend/design-system';

export const PayoutLabel = ({ children }: CommonHTMLAttributes & { children: ReactNode }) => (
  <Text size='large' color='light' css={{ margin: 0 }}>
    {children}
  </Text>
);
